import { UserType } from '../user';
export * as Api from './api';
import { Realm } from '../global';

export enum AuthGateDecision {
  ChooseAccount = 'choose-account',
  CopyProfile = 'copy-profile',
}

export enum InvestorAccessPermission {
  EditAll = 'edit:all',
  CreateAll = 'create:all',
  ReadAll = 'read:all',
  SignDocuments = 'sign:documents',
}

export enum InvestorAccessPermissionGroupKey {
  Full = 'Full',
  ReadOnly = 'ReadOnly',
  FullExceptSigning = 'FullExceptSigning',
}

export const InvestorAccessPermissionGroup: Record<
  InvestorAccessPermissionGroupKey,
  Array<InvestorAccessPermission>
> = {
  [InvestorAccessPermissionGroupKey.Full]: [
    InvestorAccessPermission.EditAll,
    InvestorAccessPermission.CreateAll,
    InvestorAccessPermission.ReadAll,
    InvestorAccessPermission.SignDocuments,
  ],
  [InvestorAccessPermissionGroupKey.FullExceptSigning]: [
    InvestorAccessPermission.EditAll,
    InvestorAccessPermission.CreateAll,
    InvestorAccessPermission.ReadAll,
  ],
  [InvestorAccessPermissionGroupKey.ReadOnly]: [
    InvestorAccessPermission.ReadAll,
  ],
};

export interface FurtherUserTokenPayload {
  _id: string;
  email: string;
  activeUserType: UserType | undefined;
  activeAccountIds: Array<string>;
  investorAccessPermissions?: Array<InvestorAccessPermission>;
  isAdminUserImpersonatingFurtherUser?: boolean;
  restrictToFirmId?: string;
  investorRealm?: Realm;
}

export enum FurtherUserErrorCode {
  ImpersonationFirmMismatch = 'IMPERSONATION_FIRM_MISMATCH',
}
export interface EncryptedHash {
  iv: string;
  content: string;
}
